import Swal from "sweetalert2";
const Api = {
  data() {
    return {};
  },
  methods: {
    async Post(Servis, Data, Mesaj) {
      return this.ActionsPost({ Service: Servis, Data: Data }).then(
        (res) => {
          if (res.Succeeded == true) {
            if (Mesaj != false) {
              if (Mesaj === undefined || Mesaj === null) {
                this.$toast.success(this.$t("ToasMessage.PostPozitif"));
              } else {
                this.$toast.success(Mesaj);
              }
            }
            this.Get();
            return res.Data;
          } else {
            this.$toast.error(this.$t("ToasMessage.PostNegatif"));
            return false;
          }
        }
      );
    },

    async Update(Servis, Data, Mesaj) {
      return this.ActionsPut({ Service: Servis, Data: Data }).then((res) => {
        if (res.Succeeded == true) {
          if (Mesaj != false) {
            if (Mesaj === undefined || Mesaj === null) {
              this.$toast.success(this.$t("ToasMessage.UpdatePozitif"));
            } else {
              this.$toast.success(Mesaj);
            }
          }
          this.Get();
          return true;
        } else {
          this.$toast.error(this.$t("ToasMessage.UpdateNegatif"));
          return false;
        }
      });
    },
    async UpdateList(Servis, Data, Mesaj) {
      return this.ActionsPutList({ Service: Servis, Data: Data }).then(
        (res) => {
          if (res.Succeeded == true) {
            if (Mesaj != false) {
              if (Mesaj === undefined || Mesaj === null) {
                this.$toast.success(this.$t("ToasMessage.UpdatePozitif"));
              } else {
                this.$toast.success(Mesaj);
              }
            }
            this.Get();
            return true;
          } else {
            this.$toast.error(this.$t("ToasMessage.UpdateNegatif"));
            return false;
          }
        }
      );
    },
    async Delete(Servis, StrId, Mesaj) {
      Swal.fire({
        title: this.$t("ToasMessage.DeletePopupBaslik"),
        text: this.$t("ToasMessage.DeletePopupContent"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: this.$t("ToasMessage.DeletePopupPozitif"),
        cancelButtonText: this.$t("ToasMessage.DeletePopupNegatif"),
      }).then((result) => {
        if (result.value) {
          this.ActionsDelete({ Service: Servis, Id: StrId }).then((res) => {
            if (res.Succeeded == true) {
              this.Get();
              if (Mesaj != false) {
                if (Mesaj === undefined || Mesaj === null) {
                  this.$toast.success(this.$t("ToasMessage.DeletePozitif"));
                } else {
                  this.$toast.success(Mesaj);
                }
              }
            } else {
              this.$toast.error(this.$t("ToasMessage.DeleteNegatif"));
            }
          });
        }
      });
    },
  },
};

export default Api;
